import React, { memo } from 'react'
import { INavRoute } from 'types/routes'
import { useUserDetails } from 'utils/hooks'
import MobileRoute from './MobileRoute'

interface IMenuProps {
  routes: INavRoute[]
}

const MobileMenu = memo<IMenuProps>(({ routes }) => {
  const { logout } = useUserDetails()
  const [subRoutes] = routes.filter(r => r.childRoutes && r.location !== '').map(r => r.childRoutes)
  const allRoutes = [...routes, ...(subRoutes || [])]
  const signOutClickHandler = () => logout()

  return (
    <div className='mobile-menu db dn-l'>
      <input type='checkbox' className='activate-menu' />
      <div className='hamburger'>
        <div className='patty' />
      </div>
      <div className='menu-wrapper'>
        <ul className='xs-grid-2'>
          {allRoutes
            .filter(route => !!route.display)
            .map(route => (
              <MobileRoute route={route} key={route.name} />
            ))}
        </ul>
        <button
          className='text-inverse btn-text-link btn-full-width btn-large'
          onClick={signOutClickHandler}
          onKeyPress={signOutClickHandler}
          role='link'>
          Sign Out
        </button>
      </div>
    </div>
  )
})

export default MobileMenu
